// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"309":"0f019a5e","760":"1f7f3f47"}[chunkId] + ".chunk.js";
};